import { isEmpty, difference } from 'underscore';
import {
  pickOutcomesByPo,
  pickOutcomesByKeys,
  orderOutcomesByPo,
} from 'InPlayOverview/helpers/outcomes';

const orderedOutcomes = (outcomes, keyOrder, template, showOutcomeDesc) => {
  // some sports (cricket and darts) have some competition with a posibility of a draw
  // and some don't. We want the markets from competitions with only 2 outcomes to have a
  // third hidden looking outcome in the middle for the "draw" (X) for the 3 column coupons
  if (outcomes.length === 2 && template === 'template_a') {
    // if we have all the keys
    if (outcomes.length < keyOrder.length) {
      return pickOutcomesByKeys(outcomes, keyOrder, showOutcomeDesc);
    }
    // if we need to rely on po fields, but make sure we get 3 of them
    return pickOutcomesByPo(outcomes, 3, showOutcomeDesc);
  }

  // if we have all keys assigned
  if (outcomes.length === keyOrder.length) {
    // if keys selected match outcomes
    if (isEmpty(difference(keyOrder, outcomes.map((o) => o.keyDimension)))) {
      return pickOutcomesByKeys(outcomes, keyOrder, showOutcomeDesc);
    }
    return pickOutcomesByPo(outcomes, outcomes.length, showOutcomeDesc);
  }

  // fall back to sorting by po instead of picking elements
  return orderOutcomesByPo(outcomes, showOutcomeDesc);
};

export default orderedOutcomes;
